import { render, staticRenderFns } from "./uploader-image.vue?vue&type=template&id=01fb6cb6&"
import script from "./uploader-image.vue?vue&type=script&lang=js&"
export * from "./uploader-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports